export const accountDetails = {
    bankName: 'UBS',
    zipCode: '8098',
    city: 'Zurich',
    country: 'Switzerland',
};

export const accountDetailsZurichDepots = {
    bankName: 'Lienhardt und Partner Privatbank Zürich AG',
    zipCode: '8024',
    city: 'Zurich',
    country: 'Switzerland',
};

export const STATIC_ZIP_CODE_FOR_BENEFICIARY = '8085';
export const STATIC_CITY_FOR_BENEFICIARY = 'Zurich';
